import React from 'react'

const Maintenence = () => {
  return (
    <div>Maintenence</div>
  )
}

export default Maintenence